import { ICellRendererParams } from 'ag-grid-community'
import { styled } from '@mui/material'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import { WbsItemStatus } from '../../../../../domain/entity/WbsItemEntity'
import { WbsItemStatusChip } from '../../../../features/WbsItemStatusChip'

export const WbsItemStatusChipCellRenderer = (
  params: ICellRendererParams<ProgressReportTableContent>
) => {
  const status = params.data?.wbsItemStatus
  if (!status) return null
  return (
    <Root>
      <WbsItemStatusChip status={status as WbsItemStatus} fitContent={true} />
    </Root>
  )
}

const Root = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  padding: '0 2px',
})
